<template>  
    <div class="columns">    
                    <div class="column is-three-fifths is-offset-one-fifth">  
                        <div>    
                        <article class="media">
                            <figure class="media-left">
                            <div 
                            class="recipe-avatar image"
                            v-if="recipe.mainImage[0]" 
                            :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+recipe.mainImage[0]+'?alt=media)' }">
                            </div>
                            </figure>
                            <div class="media-content">
                                <div class="content">
                                    <div class="is-size-5"><span class="is-size-2 caveat">For the {{recipe.name}}</span>
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="media-right">
                            </div>
                            </article>
                            <div class="content mt-20">
                                <div>
                                    <nav class="level time-serving-levels">    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Prep Time</p>    
                                                <p class="title">
                                                    <span v-if="recipe.prepTime.hours > 0">{{recipe.prepTime.hours}} hr </span>
                                                    <span v-if="recipe.prepTime.minutes > 0">{{recipe.prepTime.minutes}} min</span>
                                                    <span v-if="(recipe.prepTime.minutes + recipe.prepTime.hours) == 0">0 min</span>
                                                </p>
                                            </div>    
                                        </div>    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Cook Time</p>    
                                                <p class="title">
                                                    <span v-if="recipe.cookTime.hours > 0">{{recipe.cookTime.hours}} hr </span>    
                                                    <span v-if="recipe.cookTime.minutes > 0">{{recipe.cookTime.minutes}} min</span>
                                                    <span v-if="(recipe.cookTime.minutes + recipe.cookTime.hours) == 0">0 min</span>
                                                </p>
                                            </div>    
                                        </div>    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Servings</p>    
                                                <p class="title">{{recipe.servings}}</p>    
                                            </div>    
                                        </div>    
                                    </nav>    
                                </div> 
                                <div class="mt-50">
                                <b-collapse
                                    class="card">
                                    <div
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header recipe-header"
                                        role="button">
                                        <p class="card-header-title">
                                            Ingredients
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon
                                            pack="fas"
                                                :icon="props.open ? 'caret-up' : 'caret-down'">
                                            </b-icon>
                                        </a>
                                    </div>
                                    <div class="card-content">
                                        <div class="content">                                            
                                            <div class="columns">
                                                <div class="column ingredient-list">  
                                                <table class="table is-striped">  
                                                <tbody>
                                                    <tr v-for="(ingredient, index) in recipe.ingredients" :key="ingredient.id">
                                                    <td  v-if="index <= (recipe.ingredients.length/2)">   
                                                    <div class="field">
                                                        <b-checkbox>
                                                            <span v-html="ingredient.amount"></span>&nbsp;<span v-if="ingredient.measurement">{{ingredient.measurement}},&nbsp;</span>{{ingredient.ingredient}}
                                                        </b-checkbox>
                                                    </div>                                                            
                                                    </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                </div> 
                                                <div class="column ingredient-list">    
                                                    <table class="table is-striped">  
                                                <tbody >
                                                    <tr v-for="(ingredient, index) in recipe.ingredients" :key="ingredient.id">
                                                    <td v-if="index > (recipe.ingredients.length/2)">  
                                                    <div class="field">
                                                        <b-checkbox>
                                                            <span v-html="ingredient.amount"></span>&nbsp;<span v-if="ingredient.measurement">{{ingredient.measurement}},&nbsp;</span>{{ingredient.ingredient}}
                                                        </b-checkbox>
                                                    </div>   
                                                    </td>
                                                    </tr>
                                                    </tbody>
                                                </table> 
                                                </div> 
                                            </div>                                               
                                        </div>
                                    </div>
                                </b-collapse>  
                                <b-collapse
                                    class="card">
                                    <div
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header recipe-header"
                                        role="button">
                                        <p class="card-header-title">
                                            Instructions
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon
                                            pack="fas"
                                                :icon="props.open ? 'caret-up' : 'caret-down'">
                                            </b-icon>
                                        </a>
                                    </div>
                                    <div class="card-content">
                                        <div class="content">
                                            <!-- Post content -->    
                                            <div v-for="(item,index) in recipe.steps" :key="item.id">    
                                                <div v-if="item.image" class="columns">
                                                    <div class="column is-two-thirds step-flex">    
                                                        <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div>
                                                        <div class="step-content"><span>{{item.text}}</span></div>  
                                                    </div>    
                                                    <div class="column is-one-third">    
                                                        <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+item.image+'?alt=media'" style="width:100%;" />    
                                                    </div>   
                                                </div>
                                                <div v-else>
                                                    <div class="step-flex">    
                                                        <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div> 
                                                        <div class="step-content"><span>{{item.text}}</span></div> 
                                                    </div>   
                                                </div>   
                                            </div>                                            
                                        </div>
                                    </div>
                                </b-collapse> 
                                </div>
                            </div>    
                        </div>    
           
                        
                    </div>      
                </div>  
</template>

<script>      
export default {
    props: ['recipe']
};
</script>